/* Portafoto v13: explicit native locale selection and scoped display repairs. */
(() => {
  'use strict';
  if (window.__pfUIV13) return;
  window.__pfUIV13 = true;
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  const normalize = value => String(value || '').replace(/\s+/g,' ').trim();
  const colors = {black:'أسود',white:'أبيض',wood:'خشبي','natural wood':'خشبي طبيعي','dark wood':'خشبي داكن',gold:'ذهبي',golden:'ذهبي',beige:'بيج',grey:'رمادي',gray:'رمادي',brown:'بني'};
  const seenReveal = new WeakSet();
  const reveal = window.IntersectionObserver ? new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {entry.target.classList.remove('scroll-trigger--offscreen');obs.unobserve(entry.target);}
    });
  },{rootMargin:'0px 0px -30px 0px'}) : null;

  function nativeLocaleButton() {
    const old = document.getElementById('portafoto-lang-toggle');
    const form = document.getElementById('portafoto-localization-form');
    if (!old || !form || old.dataset.pfNativeLocale === '1') return;
    const input = form.querySelector('input[name="language_code"]');
    if (!input) return;
    /* The old toggle had an inline-layout closure doing location.assign.
       Replace that one owned button, not global click listeners. */
    const button = old.cloneNode(true);
    button.dataset.pfNativeLocale = '1';
    button.type = 'submit';
    button.setAttribute('form', form.id);
    button.removeAttribute('onclick');
    button.classList.toggle('is-en', english);
    input.value = english ? 'ar' : 'en';
    let back = form.querySelector('input[name="return_to"]');
    if (!back) {back=document.createElement('input');back.type='hidden';back.name='return_to';form.appendChild(back);}
    back.value = location.pathname + location.search;
    old.replaceWith(button);
    // Native form POST remembers the explicit preference; no auto redirect.
  }
  function formatVariants(root) {
    if (english) return;
    const selector='.cart-item-variant, .previewCartItem-variant';
    const nodes=[...(root.querySelectorAll?.(selector)||[])];if(root.matches?.(selector))nodes.push(root);
    nodes.forEach(node => {
      const raw = normalize(node.dataset.pfRawVariant || node.textContent);
      const parts = raw.split('/').map(normalize).filter(Boolean);
      const last = parts.length > 1 ? parts.pop() : '';
      /* v15: size values read "3 frames 60x90 for 4800 EGP". The tier price is
         the pre-discount list price and the line already shows the real price,
         so Arabic mode drops "for 4800 EGP" instead of leaving English in the cart. */
      const size = (parts.join(' / ') || raw).replace(/\s+for\s+[\d,.]+\s*(?:EGP|LE)\.?$/i,'');
      const main = size.replace(/^size\s*:\s*/i,'').replace(/\bframes\b/gi,'براويز').replace(/\bframe\b/gi,'برواز').replace(/(\d)\s*[xX]\s*(\d)/g,'$1×$2');
      const value = [main, colors[last.toLowerCase()] || last].filter(Boolean).join(' • ');
      if (([size, last].join(' ').match(/\d[\d,.]*/g)||[]).join('|') !== (value.match(/\d[\d,.]*/g)||[]).join('|')) return;
      if (!node.dataset.pfRawVariant) node.dataset.pfRawVariant = raw;
      if (node.textContent !== value) node.textContent = value;
    });
  }
  function displayRepairs(root=document) {
    root.querySelectorAll?.('.slick-counter.slick-slide').forEach(counter => {
      const track = counter.closest('.slick-track');if (!track) return;
      const host = track.closest('.productView-nav') || track.parentElement;
      counter.classList.remove('slick-slide','slick-current','slick-active');
      ['data-slick-index','aria-describedby','tabindex','role','style'].forEach(attr=>counter.removeAttribute(attr));
      counter.setAttribute('aria-hidden','true');host.appendChild(counter);
      if(!track.querySelector('.slick-current'))track.querySelector('.slick-slide:not(.slick-cloned)')?.classList.add('slick-current','slick-active');
    });
    const candidates = [...(root.querySelectorAll?.('.scroll-trigger--offscreen') || [])];
    if(root.matches?.('.scroll-trigger--offscreen'))candidates.push(root);
    candidates.forEach(node => {
      if(seenReveal.has(node))return;
      seenReveal.add(node);
      const r=node.getBoundingClientRect();
      if(r.bottom>0 && r.top<innerHeight)node.classList.remove('scroll-trigger--offscreen');
      else if(reveal)reveal.observe(node);
      else node.classList.remove('scroll-trigger--offscreen');
    });
    formatVariants(root);
  }
  function expiry() {
    const expired=Date.now()>Date.parse('2026-09-30T23:59:59+03:00');
    document.documentElement.classList.toggle('pf-v13-offer-expired',expired);
    return expired;
  }
  function boot() {
    nativeLocaleButton();displayRepairs();expiry();
    new MutationObserver(records=>{
      const roots=new Set();
      records.forEach(r=>r.addedNodes.forEach(n=>{if(n.nodeType===1 && !n.closest('script,style,head'))roots.add(n);}));
      roots.forEach(root=>{let p=root.parentElement;while(p){if(roots.has(p))return;p=p.parentElement;}displayRepairs(root);});
    }).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',event=>displayRepairs(event.target));
    window.addEventListener('pageshow',expiry);
    document.addEventListener('visibilitychange',expiry);
    const remaining=Date.parse('2026-09-30T23:59:59+03:00')-Date.now()+1000;
    if(remaining>0 && remaining<2147483647)setTimeout(expiry,remaining);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
